import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { TunnelProtocolEnum, TunnelProtocolToPort } from "@/model/data/enums/TunnelProtocolEnum";
import { ApiGenericResponse } from "../ApiGenericResponse";

const ENDPOINT = "/remotelink/session/stop";

export class StopAgentTunnelSessionCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: StopAgentTunnelSessionReqData;

    constructor(installationName: string, protocolPort: number) {
        super();
        this.payload = new StopAgentTunnelSessionReqData(installationName, protocolPort);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class StopAgentTunnelSessionReqData {
    installationName: string;
    servicePort: number;

    constructor(installationName: string, protocolPort: number) {
        this.installationName = installationName;
        this.servicePort = protocolPort;
    }
}
